var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.33337C8.72386 1.33337 8.5 1.55723 8.5 1.83337C8.5 2.10952 8.72386 2.33337 9 2.33337V1.33337ZM3.68922 4.53756C3.88421 4.34203 3.88376 4.02545 3.68823 3.83046C3.49269 3.63547 3.17611 3.63591 2.98112 3.83145L3.68922 4.53756ZM16.5 9.83337C16.5 13.9755 13.1421 17.3334 9 17.3334V18.3334C13.6944 18.3334 17.5 14.5278 17.5 9.83337H16.5ZM9 17.3334C4.85786 17.3334 1.5 13.9755 1.5 9.83337H0.5C0.5 14.5278 4.30558 18.3334 9 18.3334V17.3334ZM9 2.33337C13.1421 2.33337 16.5 5.69124 16.5 9.83337H17.5C17.5 5.13895 13.6944 1.33337 9 1.33337V2.33337ZM1.5 9.83337C1.5 7.76597 2.33584 5.89474 3.68922 4.53756L2.98112 3.83145C1.44845 5.36843 0.5 7.49062 0.5 9.83337H1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.16667V0.5L7 1.83333L9 3.16667Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.83337H11",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepBack);
export default __webpack_public_path__ + "static/media/stepBack.42a1a0df15190a15636c5864ebdac579.svg";
export { ForwardRef as ReactComponent };